export default {
  ORIGINE: "ORIGINES",
  INDICE_REPARABILITE: "INDICE_REPARABILITE",
  CLASSE_ENERGETIQUE: "CLASSE_ENERGETIQUE",
  SAISON: "DE_SAISON",
  PECHE: "INFOS_PECHE",
  COMPOSITION: "COMPO_INGRE_ALLERG",
  CRACTERISTIQUES: "CARAC_PRODUIT",
  COMPLEMENTAIRES: "INFOS_COMPLEMENTAIRES",
  DOCUMENTS: "DOCUMENTS",
  PHYTO: "PHYTO",
  EMPLOI: "MODE_EMPLOI",
  CONSEILS: "CONSEILS",
  LEGALES: "MENTIONS_LEGALES",
  MARQUE: "MARQUE",
  TECHNICAL_CRACTERISTICS: "CARACTERISTIQUES_TECHNIQUES",
  PDF: "pdf",
  VALEURS_NUTRITIONNELLES: "VALEURS_NUTRITIONNELLES",
  INFOS_NUTRITIONNELLES: "INFOS_NUTRITIVES",
  DESCRIPTIF: 'DESCRIPTIF',
  DOWNLOAD_NOTICE: "dl-notice",
  ALCOOL: "ALCOOL"
}
